/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-11-09 17:18:41
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-15 16:14:42
 * @FilePath: \sea-page-game\src\config\languages\vi-VN.js
 */
/*
 * @Author: jiansuiwang@rastar.com
 * @Date: 2023-10-30 11:23:02
 * @LastEditors: jiansuiwang@rastar.com
 * @LastEditTime: 2023-11-08 10:25:31
 * @FilePath: \sea-page-game\src\config\languages\id-ID.js
 */
module.exports = {
  message: {
      // 首页
      navigator_website: 'Trang Chủ',
      navigator_collect: 'Ưa Thích',
      navigator_service: 'CS',
      navigator_teach: 'Hướng Dẫn',
      navigator_logout: 'Đăng Xuất',
      navigator_mobile_logout: 'Mobile Login',// 实际也不显示
      navigator_email_logout: 'Email',
      navigator_download: 'Tải',
      // 登录、注册页
      navigator_signIn: 'Đăng Ký',
      navigator_lang: 'Đăng Nhập',
      navigator_email: 'Email',
      input_account: 'Xin nhập tên tài khoản',
      input_mobile: 'Xin nhập SĐT',
      input_password: 'Nhập mật khẩu',
      input_password_again: 'Xin nhập lại mật khẩu',
      input_email_address: 'Xin nhập địa chỉ email',
      input_reset_email: 'Xin nhập tên tài khoản hoặc địa chỉ email cần thiết lập lại mật khẩu',
      input_reset_password: ', xin xác minh bằng các phương pháp sau rồi đặt lại mật khẩu',
      retrieve_password: 'Tìm lại mật khẩu',
      forget_password: 'Quên mật khẩu',
      next_step: 'Bước tiếp',
      bind_email: 'Liên kết Email',
      input_bind_email: 'Xin nhập tài khoản đã liên kết email',
      bound_email: 'Đã liên kết Email',
      enter_code: 'Xin nhập mã xác minh',
      get_code: 'Gửi mã xác minh',
      get_code_seconds: 's',
      security_verification: 'Xác minh bảo mật',
      inputTheAnswer: 'Xin nhập mã xác minh trong hình',
      noneSelectArea: "Xin chọn mã vùng SĐT",
      confirm: 'Xác Nhận',
      bind: 'Liên Kết',
      agree: 'Đọc và đồng ý',
      tips_1: 'SĐT chưa đăng ký sẽ được tự động đăng ký và đăng nhập sau khi xác minh',
      copy_success: 'Sao chép thành công!',
      copy_fail: 'Xin sao chép thủ công',
      incorrect_email: 'Xin nhập đúng định dạng email!',
      emailTips1: 'Mật khẩu không được chứa dấu cách hoặc ký tự tiếng Trung!',
      emailTips2: 'Xin nhập mật khẩu ít nhất 6 chữ số',
      emailTips3: 'Hai mật khẩu không bằng nhau',
      emailTips4: 'Mã xác minh sai',
      emailTips5: 'Xin nhập tên tài khoản gồm 4-12 chữ và số',
      emailTips6: 'Xin nhập mật khẩu gồm 6-20chuwx và số kết hợp ký tự đặc biệt không phải tiếng Trung',
      emailTips7: 'Hai mật khẩu không giống nhau',
      selectAreaCode: 'Chọn mã vùng',
      urlError: 'Địa chỉ truy cập đang lỗi!',
      tips: 'Lưu ý',
      verifiedTips1:'Trò chơi dành chơi người chơi 18 tuổi trở lên',
      verifiedTips2:'Đăng nhập thất bại, bạn cần hoàn tất xác thực tên thật trước khi có thể trải nghiệm trò chơi',
      // 底部
      rules_clause: 'Điều khoản dịch vụ',
      privacy_clause: 'Chính sách bảo mật',
      service_email: 'CS Email:',
      EmailAddress: 'maplestoryr.sea@gmail.com',
      // 教程页
      infoTitle: 'Hướng dẫn đăng nhập và nạp tiền bản PC'
  }
}